import { connect } from 'react-redux';
import { ManageGroupComponent } from './manage-group.component';
import { AppState } from '../../app.state';

export const ManageGroup = connect((sState: AppState) => ({ sState }))(
  //@ts-ignore
  ManageGroupComponent as any
) as unknown as typeof ManageGroupComponent;
